import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';
import { AppConstants } from '../common/constants';
import { StorageService } from './storage.service';
import { map } from 'rxjs/operators';
import { PermissionService } from './permission.service';
import { CustomURLEncoder } from '../models';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;
  constructor(
    private http: HttpClient,
    private storage: StorageService,
    private permissionService: PermissionService,
    private storageService: StorageService
  ) {
    this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  public deleteCurrentUserValue(): any {
    this.currentUserSubject.next(null);
  }

  login(username: string, password: string) {

    const body = new HttpParams({ encoder: new CustomURLEncoder() })
      .set('grant_type', 'password')
      .set('username', username)
      .set('password', password);

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' 
    });

    return this.http.post<any>(`${AppConstants.API_URL}token`, body.toString(), { headers })
      .pipe(map(user => {
        if (user && user.access_token) {
          this.storage.setCurrentSession(user);
          this.currentUserSubject.next(user);
          this.permissionService.GetPermissionsByUser(+user.Id).subscribe(next => {
            if (next.Result) {
              this.storageService.SetPermissions(next.Permissions);
            }
            else {
            }
          }, error => {

          });
        }

        return user;
      }));
  }
}
